import type { AdminListFiatTransactionsParams } from '../api'
import adminPaymentService from './admin-payment.service'
import { EPaymentQueryKey } from './admin-payment.types'

export const adminListFiatTransactionsOptions = (
  params: AdminListFiatTransactionsParams,
) => {
  return {
    queryKey: [EPaymentQueryKey.ADMIN_LIST_FIAT_TRANSACTIONS, params],
    queryFn: () => adminPaymentService.adminListFiatTransactions(params),
  }
}
